"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalBankAccountType = void 0;
var ExternalBankAccountType;
(function (ExternalBankAccountType) {
    ExternalBankAccountType["PERSONAL_CHECKING"] = "PERSONAL_CHECKING";
    ExternalBankAccountType["PERSONAL_SAVINGS"] = "PERSONAL_SAVINGS";
    ExternalBankAccountType["BUSINESS_CHECKING"] = "BUSINESS_CHECKING";
    ExternalBankAccountType["BUSINESS_SAVINGS"] = "BUSINESS_SAVINGS";
})(ExternalBankAccountType || (exports.ExternalBankAccountType = ExternalBankAccountType = {}));
